(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ayonae-cart-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
    if (!event.target.matches('.ay-cart-offer__form select')) return;
    const price = event.target.selectedOptions[0]?.dataset.offer;
    const output = event.target.closest('.ay-cart-offer__product')?.querySelector('[data-offer-price]');
    if (price && output) output.textContent = price;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayonae-quick-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ayonae-shipping-progress')) {
    customElements.define('ayonae-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.dialog = this.closest('dialog');
        this.refresh = () => this.update();
        document.addEventListener('cart:update', this.refresh, { signal: this.abort.signal });
        document.addEventListener('discount:update', this.refresh, { signal: this.abort.signal });
        this.observer = new MutationObserver(() => {
          if (this.dialog.open) this.update();
        });
        if (this.dialog) {
          this.observer.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
          if (this.dialog.open) this.update();
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.request?.abort();
        this.observer?.disconnect();
      }
      async update() {
        if (this.dataset.country !== 'NO') {
          this.hidden = true;
          return;
        }
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        try {
          const response = await fetch(this.dataset.cartUrl, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
            signal: request.signal
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (request.signal.aborted) return;
          if (cart.currency !== 'NOK' || !Number.isFinite(cart.total_price)) {
            this.hidden = true;
            return;
          }
          const total = Math.max(0, cart.total_price);
          const remaining = Math.max(0, 39900 - total);
          const amount = new Intl.NumberFormat('nb-NO', {
            minimumFractionDigits: remaining % 100 ? 2 : 0,
            maximumFractionDigits: 2
          }).format(remaining / 100);
          this.querySelector('p').textContent = remaining === 0
            ? this.dataset.unlocked
            : this.dataset.remaining.replace('[amount]', amount);
          this.querySelector('progress').value = Math.min(total, 39900);
          this.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
